import React from 'react';

import CustomTh from '../shared/table/CustomTh';
import InteractionItem from './InteractionItem';
import ListView from '../shared/lists/ListView';

const InteractionList = ({
    addItem,
    canAdd,
    data: { items },
    editItem,
    fetchData
}) => {
    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <CustomTh width="100px" content="Date" />
                <CustomTh style={{ textAlign: 'center' }} content="Description" />
                <CustomTh width="50px" hide="md" content="User" />
                <CustomTh width="90px" />
            </tr>
        </thead>
    );

    const listItems = items && items.map((item) =>
        <InteractionItem
            editItem={() => editItem(item.id)}
            fetchData={fetchData}
            item={item}
            key={item.id}
        />);

    return (
        <ListView
            addItem={addItem}
            canAdd={canAdd}
            itemName="Log Information"
            items={listItems}
            tableHead={tableHead}
        />
    );
}

export default InteractionList;